import PropTypes from 'prop-types';
import Box from 'components/UI/Box/Box';
import Button from 'components/UI/Button';
import luchitoTracking from 'assets/images/digital-loan/luchito-tracking.png';
import luchitoNewLoan from 'assets/images/digital-loan/luchito-new-loan.png';

const DigitalLoanHomeBanner = ({
  variant,
  literals,
  onClick,
}) => {
  const isActive = variant === 'active';
  const hero = isActive ? luchitoTracking : luchitoNewLoan;

  return (
    <Box
      className={`digital-loan-home-card digital-loan-home-card--${variant} mb-3`}
      padding='lg'
    >
      <div className='digital-loan-home-card__content'>
        <div className='digital-loan-home-card__copy'>
          <h3 className='digital-loan-home-card__title'>
            {isActive ? literals.activeTitle : literals.newTitle}
          </h3>
          {isActive ? (
            <p className='digital-loan-home-card__status'>{literals.activeStatus}</p>
          ) : (
            <p className='digital-loan-home-card__subtitle'>{literals.newSubtitle}</p>
          )}
          <Button
            text={isActive ? literals.activeCta : literals.newCta}
            onClick={onClick}
          />
        </div>
        <img
          className='digital-loan-home-card__hero'
          src={hero}
          alt={literals.heroAlt}
        />
      </div>
    </Box>
  );
};

DigitalLoanHomeBanner.propTypes = {
  variant: PropTypes.oneOf(['new', 'active']).isRequired,
  literals: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default DigitalLoanHomeBanner;
